import React from 'react';
import './css/TableContainer.css';

const TableContainer = ({
  children,
  className = '',
  containerStyle = {},
  responsiveStyle = {},
  tableClass = '',
}) => {
  return (
    <div
      className={`table-container w-100 small mb-1 ${className}`}
      style={{
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...containerStyle,
      }}
    >
      <div
        className="table-responsive-sm mb-1"
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          minHeight: responsiveStyle.minHeight || '280px',
          maxHeight: responsiveStyle.maxHeight || '100vh',
          flex: '1 1 auto',
          ...responsiveStyle,
        }}
      >
        <table className={`table table-sm table-striped table-compact ${tableClass}`}>
          {children}
        </table>
      </div>
    </div>
  );
};

export default TableContainer;
